import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { colors, sizes, breakpoints, mixins, fonts } from "../../css-variables"
import PageSection from "../../page-sections/PageSection"
import AllChaptersData from "../../collections/AllChapters"
import ChapterDropdownCard from "./ChapterDropdownCard"
import stateOptions from "../../../utils/state-options"

const ChapterSearch = ({ international, states}) => {
  const [selectedCountry, setSelectedCountry] = useState("All Countries")
  const [selectedState, setSelectedState] = useState("All U.S. States")
  const [chapterData] = useState(AllChaptersData().nodes)
  const [filteredChapters, setFilteredChapters] = useState([])

  const filterChapters = (property, value) =>
  chapterData.filter((chapter) =>
    Array.isArray(chapter.chapterDetails[property])
      ? chapter.chapterDetails[property].includes(value)
      : chapter.chapterDetails[property] === value
  )

  const getCountryOptions = (chapterData) => {
    let countries = chapterData.reduce((acc, chapter) => {
      let { csCountry } = chapter.chapterDetails
      return Array.isArray(csCountry)
        ? [...acc, ...csCountry]
        : [...acc, csCountry]
    }, [])
    return [...new Set(countries)].sort()
  }

  useEffect(() => {
    if (
      selectedCountry !== 'All Countries' &&
      selectedCountry !== 'United States'
    ) {
      setSelectedState('All U.S. States')
      let filteredChapters = filterChapters('csCountry', selectedCountry)
      setFilteredChapters(filteredChapters)
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState !== 'All U.S. States') {
      setSelectedCountry('All Countries')
      let filteredChapters = filterChapters('csState', selectedState)
      setFilteredChapters(filteredChapters)
    }
  }, [selectedState])

  return (
    <>
      <StyledButtonWrapper>
        <FilterBox>
          {international && (
            <FilteredDiv>
              <FilteredSelect
                name="countries"
                id="countries"
                onChange={e => setSelectedCountry(e.target.value)}
                value={selectedCountry}
              >
                <option value="All Countries" disabled>
                  Search by Country
                </option>
                {getCountryOptions(chapterData).map(country => {
                  if(country !== "United States"){
                    return <option key={country} value={country}>{country}</option>
                  }
                  return
                })}
              </FilteredSelect>
            </FilteredDiv>
          )}
          {states && (
            <FilteredDiv>
              <FilteredSelect
                name="states"
                id="states"
                onChange={e => setSelectedState(e.target.value)}
                value={selectedState}
              >
                <option className="titleOption" value="All U.S. States" disabled>
                  Search by U.S. State
                </option>
                {stateOptions.map(state => {
                  return <option key={state.VALUE} value={state.VALUE}>{state.LABEL}</option>
                })}
              </FilteredSelect>
            </FilteredDiv>
            )}
        </FilterBox>
      </StyledButtonWrapper>
      <ResultsBoxWrapper>
        {filteredChapters.length === 0 ? (
          <div>
            {selectedCountry !== "All Countries" ||
            selectedState !== "All U.S. States" ? (
              <p style={{ width: `100%`, textAlign: `center` }} className="noGroupResults">
                There are no groups found in this area. Find out how you can <a href="/waa-groups/start-a-group/">start a new chapter or group</a>!
              </p>
            ) : null}
          </div>
        ) : (
          filteredChapters.map(chapter => <ChapterDropdownCard key={chapter.title} chapter={chapter} />)
        )}
      </ResultsBoxWrapper>
    </>
  )
}

  const StyledButtonWrapper = styled.div`
    padding-bottom: 58px;
  `

  const FilterBox = styled.div`
    width: 252px;
    margin: 0 auto;
  `

  const FilteredDiv = styled.div`
    position: relative;
    width: 252px;
    color: ${colors.titleWhite};
    &:after{
      content:'';
          border: solid #ffffff;
          border-width: 0 2px 2px 0;
          display: inline-block;
          padding: 4px;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          position:absolute;
          left: 14px;
          top:16px;
    }
  `
  const FilteredSelect = styled.select`
    position: relative;
    text-align: left;
    padding-left: ${sizes.s36};
    color: ${colors.titleWhite};
    width: 100%;
    background-color: ${colors.buttonRed};
    height: 48px;
    border: none;
    appearance: none;
    &:focus {
      outline: none;
    }
    cursor: pointer;
    option{
      background-color: white;
      color: black;
    }
  `

  const ResultsBoxWrapper = styled.div`
    max-width: 760px;
    margin: 0 auto;
    a {
      text-decoration: none;
      span {
        font-family: ${fonts.redHatText};
        color: ${colors.bgRed};
      }
    }
    ul {
      list-style-type: none;
      li {
        margin-top: 4px;
      }
    }
    .noGroupResults{
      a{
        ${mixins.a}
        text-decoration: underline;
      }
    }
  `

export default ChapterSearch
